import React, { useState, useRef, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import product from '../../../../assets/images/product_image.svg';
import useMedicineLayoutStore from '../medicine.zustandstore';
import MedAddToCartBtn from '../components/med-add-to-cart-btn.component';
import '../medicine.css';

function MedicineList() {
	const [slideOffsets, setSlideOffsets] = useState({});
	const [isTransitioning, setIsTransitioning] = useState({});
	const carouselRefs = useRef({});

    const medicines = useMedicineLayoutStore((state) => state.medicines);

    useEffect(() => {
        const offsets = {};
        const transitions = {};
        medicines.forEach((med) => {
          offsets[med.id] = 0;
          transitions[med.id] = true;
          if (med.images?.length > 1) {
            let index = 0;
            const totalImages = med.images.length;
            const intervalId = setInterval(() => {
              index += 1;
              if (index === totalImages) {
                setTimeout(() => {
                  setIsTransitioning(prev => ({ ...prev, [med.id]: false }));
                  setSlideOffsets(prev => ({ ...prev, [med.id]: 0 }));
                }, 600);
              }
              setIsTransitioning(prev => ({ ...prev, [med.id]: true }));
              setSlideOffsets(prev => ({ ...prev, [med.id]: index }));
              if (index >= totalImages) index = 0;
            }, 3000);
            carouselRefs.current[med.id] = intervalId;
          }
        });
        setSlideOffsets(offsets);
        setIsTransitioning(transitions);
        return () => {
          Object.values(carouselRefs.current).forEach(clearInterval);
        };
      }, [medicines]);
	return (
			<><Grid
            container
            spacing={2}
            sx={{
                marginTop: '20px',
                display: 'flex',
                rowGap: '20px',
                columnGap: '30px',
                justifyContent: 'center',
            }}
            columns={{ xs: 1, sm: 8, md: 12 }}
        >
            {medicines.map(({ images, medicine_name, price, id }, index) => (
                <Grid key={'medicine-' + index}>
                    <Card
                        sx={{
                            width: 260,
                            height: 300,
                            padding: '14px',
                            boxSizing: 'border-box',
                        }}
                    >
                        {images.length === 0 ? (
                            <CardMedia
                                component='img'
                                height='120'
                                image={product} // fallback/default image
                                sx={{ objectFit: 'contain' }} />
                        ) : (
                            <div style={{
                                width: '100%',
                                height: '120px',
                                overflow: 'hidden',
                                position: 'relative',
                            }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        width: `${(images.length + 1) * 100}%`,
                                        transform: `translateX(-${(slideOffsets[id] || 0) * (100 / (images.length + 1))}%)`,
                                        transition: isTransitioning[id] ? 'transform 0.6s ease-in-out' : 'none',
                                    }}
                                >
                                    {[...images, images[0]].map((img, i) => (
                                        <CardMedia
                                            key={i}
                                            component='img'
                                            image={img.imageUrl}
                                            alt={`medicine-${i}`}
                                            sx={{
                                                width: `${100 / (images.length + 1)}%`,
                                                height: '120px',
                                                objectFit: 'contain',
                                            }} />
                                    ))}
                                </div>
                            </div>
                        )}
                        <CardContent
                            style={{ padding: 4 }}
                            sx={{ height: '40px', boxSizing: 'border-box' }}
                        >
                            <Typography gutterBottom className='doc-name'>
                                {medicine_name}
                            </Typography>
                        </CardContent>
                        <Typography gutterBottom className='doc-name'>
                            Price:{price}
                        </Typography>
                        <CardActions
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <MedAddToCartBtn medicine={medicines[index]}/>
                        </CardActions>
                    </Card>
                </Grid>
            ))}
        </Grid>
        </>
	);
}

export default MedicineList;
